import { oktaAuthApiRef } from '@backstage/core-plugin-api';
import type { SignInProviderConfig } from '@backstage/core-components';

export const oktaProvider: SignInProviderConfig = {
  id: 'okta-auth-provider',
  title: 'Okta',
  message: 'Sign in using Okta',
  apiRef: oktaAuthApiRef,
};
